module.exports = __webpack_public_path__ + "assets/bg_steps_icn_2@1x.f4c16642.svg";